<template>
  <div class="och-field--conditional mb-10">
    <template v-for="(conditional, index) in conditionalGroup.list">
      <template v-if="conditional.type === 'conditionalGroup'">
        <div
          :key="`conditionalGroupOperator-${index}`"
          class="d-inline-flex"
          v-if="index !== 0"
        >
          <v-select
            :items="operatorOptionList"
            v-model="conditional.booleanOperator"
          ></v-select>
        </div>
        <conditional-group
          :conditionalGroup="conditional"
          :entityName="entityName"
          :key="`conditionalGroup-${index}`"
          :optionAttributeEntityName="optionAttributeEntityName"
          @remove="conditionalGroup.list.splice(index, 1)"
        ></conditional-group>
      </template>
      <template v-else>
        <div
          :key="`conditionalOperator-${index}`"
          class="d-inline-flex"
          v-if="index !== 0"
        >
          <v-select
            :items="operatorOptionList"
            placeholder="Group Operator..."
            v-model="conditional.booleanOperator"
          ></v-select>
        </div>
        <conditional
          :conditional="conditional"
          :entityName="entityName"
          :key="`conditional-${index}`"
          :optionAttributeEntityName="optionAttributeEntityName"
          @remove="conditionalGroup.list.splice(index, 1)"
        ></conditional
      ></template>
    </template>
    <div>
      <v-btn
        @click="conditionalGroup.list.push(conditionalFactory())"
        color="primary"
        outlined
        small
        >Add Check</v-btn
      >
      <v-btn
        @click="conditionalGroup.list.push(conditionalGroupFactory())"
        class="ml-2"
        color="primary"
        outlined
        small
        >Add Check Group</v-btn
      >
      <v-btn
        @click="$emit('remove')"
        class="ml-2"
        color="primary"
        outlined
        small
        >Remove Check Group</v-btn
      >
    </div>
  </div>
</template>

<script>
import Conditional from "./Conditional";

export default {
  components: {
    Conditional,
  },
  data() {
    return {
      operatorOptionList: ["AND", "OR"],
    };
  },
  methods: {
    conditionalFactory() {
      return { type: "conditional" };
    },
    conditionalGroupFactory() {
      return { type: "conditionalGroup", list: [] };
    },
  },
  name: "conditional-group",
  props: {
    conditionalGroup: {
      required: true,
      type: Object,
    },
    optionAttributeEntityName: {
      required: true,
      type: String,
    },
    entityName: {
      required: true,
    },
  },
};
</script>
